module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/THE-LAKEHOUSE.7c8d049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/THE-LAKEHOUSE.jpg
// module id = /5KE
// module chunks = 0